import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import ScrollOnTop from "../ScrollOnTop";

export default function Layout({ children }) {
  return (
    <>
      <Header />
       <ScrollOnTop/>
      {children}
      <Footer />
    </>
  );
}
